<p-table stripedRows #dtServiceItemHistory
    [value]="items"
    dataKey="id"
    selectionMode="single"
    editMode="row"
    [scrollable]="true"
    scrollHeight="flex"
    [virtualRowHeight]="dropdownItemHeight"
    [tableStyle]="{ 'min-width': '90em', height: 'unset' }"
>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td colspan="10" style="text-align: center">
                <div class="tabulator-placeholder">
                    <span> No Data Available. Select/Check Service Item in top section to view history. </span>
                </div>
            </td>
        </tr>
    </ng-template>
    <ng-template #header let-item>
        <!-- Column Header/Sorting -->
        <tr>
            <!-- Edit -->
            <th class="edit-cell"></th>
            <!-- Status -->
            <th class="status-cell">
                <i
                    class="pi pi-exclamation-circle"
                    title="Status"
                ></i>
            </th>
            <!-- Service Item -->
            <th pSortableColumn="ServiceItem">
                Service Item
                <p-sortIcon
                        field="ServiceItem"
                        ariaLabel="Activate to sort"
                        ariaLabelDesc="Activate to sort in descending order"
                        ariaLabelAsc="Activate to sort in ascending order"
                    ></p-sortIcon>
            </th>
            <!-- Period Start -->
            <th pSortableColumn="SessionStart">
                Period Start
                <p-sortIcon
                        field="SessionStart"
                        ariaLabel="Activate to sort"
                        ariaLabelDesc="Activate to sort in descending order"
                        ariaLabelAsc="Activate to sort in ascending order"
                    ></p-sortIcon>
            </th>
            <!-- Period End -->
            <th pSortableColumn="SessionEnd">
                Period End
                <p-sortIcon
                        field="SessionEnd"
                        ariaLabel="Activate to sort"
                        ariaLabelDesc="Activate to sort in descending order"
                        ariaLabelAsc="Activate to sort in ascending order"
                    ></p-sortIcon>
            </th>
            <!-- Account -->
            <th pSortableColumn="Account">
                Account
                <p-sortIcon
                        field="Account"
                        ariaLabel="Activate to sort"
                        ariaLabelDesc="Activate to sort in descending order"
                        ariaLabelAsc="Activate to sort in ascending order"
                    ></p-sortIcon>
            </th>
            <!-- Service Item Cost -->
            <th pSortableColumn="ServiceItemCost">
                Service Item Cost
                <p-sortIcon
                        field="ServiceItemCost"
                        ariaLabel="Activate to sort"
                        ariaLabelDesc="Activate to sort in descending order"
                        ariaLabelAsc="Activate to sort in ascending order"
                    ></p-sortIcon>
            </th>
            <!-- Service item Price -->
            <th pSortableColumn="ServiceItemPrice">
                Service Item Price
                <p-sortIcon
                        field="ServiceItemPrice"
                        ariaLabel="Activate to sort"
                        ariaLabelDesc="Activate to sort in descending order"
                        ariaLabelAsc="Activate to sort in ascending order"
                    ></p-sortIcon>
            </th>
            <!-- Modified By -->
            <th pSortableColumn="ModifiedBy">
                Modified By
                <p-sortIcon
                        field="ModifiedBy"
                        ariaLabel="Activate to sort"
                        ariaLabelDesc="Activate to sort in descending order"
                        ariaLabelAsc="Activate to sort in ascending order"
                    ></p-sortIcon>
            </th>
            <!-- Modified Date -->
            <th pSortableColumn="ModifiedDate">
                Modified Date
                <p-sortIcon
                        field="ModifiedDate"
                        ariaLabel="Activate to sort"
                        ariaLabelDesc="Activate to sort in descending order"
                        ariaLabelAsc="Activate to sort in ascending order"
                    ></p-sortIcon>
            </th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-item let-edit="editing">
        <tr [pSelectableRow]="item"
            [pEditableRow]="item"
            data-id="row-{{ item.id }}"
            [ngClass]="{
                'ui-editing-row': edit && editing?.id === item?.id
            }"
        >
            <!-- Edit -->
            <td class="edit-cell">
                <button
                    *ngIf="
                        !edit && (!editing?.id || editing?.id === item?.id)
                    "
                    pButton
                    type="button"
                    pInitEditableRow
                    icon="pi pi-pencil"
                    class="p-button-rounded p-button-text"
                    (click)="onRowEditInit(item)"
                    title="Edit"
                ></button>
                <button
                    *ngIf="edit"
                    pButton
                    type="button"
                    pSaveEditableRow
                    icon="pi pi-check"
                    class="p-button-rounded p-button-text p-button-success"
                    (click)="onRowEditSave(item)"
                ></button>
                <button
                    *ngIf="edit"
                    pButton
                    type="button"
                    pCancelEditableRow
                    icon="pi pi-times"
                    class="p-button-rounded p-button-text p-button-danger"
                    (click)="onRowEditCancel(item)"
                ></button>
            </td>
            <!-- Status -->
            <td class="status-cell">
                <div (click)="onStatusClick(item)" class="status-cell">
                    <ef-status-icon
                        [status]="item?.Status?.StatusCode"
                        [message]="item?.Status?.Message"
                    ></ef-status-icon>
                </div>
            </td>
            <!-- Service Item -->
            <td class="disabled">
                {{ item?.ServiceItem }}
            </td>
            <!-- Session Start -->
            <td class="disabled">
                {{ item?.SessionStart }}
            </td>
            <!-- Session End -->
            <td class="disabled">
                {{ item?.SessionEnd }}
            </td>
            <!-- Account -->
            <td class="disabled">
                {{ item?.Account }}
            </td>
            <!-- Service Item Cost -->
            <td>
                <p-cellEditor>
                    <ng-template *ngIf="!item.IsReadOnly" pTemplate="input">
                        <input pInputText [(ngModel)]="item.ServiceItemCost" />
                    </ng-template>
                    <ng-template *ngIf="item.IsReadOnly" pTemplate="input">
                        {{ item?.ServiceItemCost | currency }}
                    </ng-template>
                    <ng-template pTemplate="output">
                        {{ item?.ServiceItemCost | currency }}
                    </ng-template>
                </p-cellEditor>
            </td>
            <!-- Service item Price -->
            <td>
                <p-cellEditor>
                    <ng-template *ngIf="!item.IsReadOnly" pTemplate="input">
                        <input pInputText [(ngModel)]="item.ServiceItemPrice" />
                    </ng-template>
                    <ng-template *ngIf="item.IsReadOnly" pTemplate="input">
                        {{ item?.ServiceItemPrice | currency }}
                    </ng-template>
                    <ng-template pTemplate="output">
                        {{ item?.ServiceItemPrice | currency }}
                    </ng-template>
                </p-cellEditor>
            </td>
            <!-- Modified By -->
            <td class="disabled">
                {{ item?.Modifiedby }}
            </td>
            <!-- Modified Date -->
            <td class="disabled">
                {{ item?.Modifieddate }}
            </td>
        </tr>
    </ng-template>
</p-table>
